 <template>
  <div>
    <v-dialog
      v-model="single_update_tran"
      max-width="1200"
      persistent
      max-height="none"
      style="max-height:none !important;"
    >
      <v-card :loading="loading">
        <v-card-title class="headline" style="padding-top:0px;padding-bottom:0px;">
          <v-col cols="11" style="padding-top:0px;padding-bottom:0px;">Update Transaction</v-col>
          <v-col cols="1" style="padding-top:0px;padding-bottom:0px;">
            <v-btn icon>
              <v-icon size="28px" class="drag-icon">mdi-drag-variant</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text style="padding-bottom:0px;">
          <v-row dense>
            <v-col cols="12">
              <v-checkbox
                dense
                v-model="update_transaction.update_locked_trans"
                hide-details
                label="Allow to update locked transaction"
                class="mt-0 pt-0"
                @change="enableUpdate()"
              ></v-checkbox>
            </v-col>
            <v-col
              cols="12"
              style="color:#a61f38;"
              v-if="selected_item.generated_inv_id"
            >Transaction Invoiced can not Edit</v-col>
            <v-col
              cols="12"
              style="color:#a61f38;"
              v-if="!selected_item.generated_inv_id && is_locked"
            >Transaction is Locked</v-col>
            <v-col cols="2">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="project_selected_status"
                @change="getProjectByStatus()"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                dense
                :items="project_of_selected_status_new"
                v-model="update_transaction.project_id"
                outlined
                hide-details
                clearable
                label="Project"
                @clear="project_group_list=[];misc_type=false;sales_order_data={},project_selected_status='1';getProjectByStatus();"
                @change="
                  update_transaction.invoice_group_id = null;
                  update_transaction.invoice_item_id = null;
                  update_transaction.invoice_id = null;
                  getProjectType();
                  getGroupOfProject();
                  getInvoiceList(); 
                "
              >
                <template v-slot:item="{ index, item }">
                  <div v-if="item.text == 'No Project'" class="v-list-item__content">
                    <div
                      class="v-list-item__title error--text"
                      style="font-size: 15px"
                    >{{ item.text }}</div>
                  </div>
                  <div v-else class="v-list-item__content">
                    <div class="v-list-item__title">{{ item.text }}</div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="7"></v-col>
            <v-col cols="2">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="vendor_selected_status"
                @change="getTransactionSelectors()"
                placeholder="All"
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="3">
              <v-radio-group
                v-model="update_transaction.expence"
                row
                dense
                hide-details
                class="mt-2"
              >
                <v-radio label="Vendor" :value="false"></v-radio>
                <v-radio label="Chart of Account" :value="true"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="3">
              <v-autocomplete
                dense
                :items="expence_list"
                v-model="update_transaction.vendor_id"
                outlined
                hide-details
                v-if="update_transaction.expence"
                clearable
                class="focus-on-vendor-expence3"
                label="Chart Of Account"
                @change="
                update_transaction.invoice_group_id = null;
                update_transaction.invoice_item_id = null;
                update_transaction.invoice_id = null;
                getGroupOfProject();
              "
              />

              <v-autocomplete
                dense
                :items="vendor_list"
                v-model="update_transaction.vendor_id"
                outlined
                hide-details
                clearable
                label="Vendor"
                class="focus-on-vendor-expence3"
                @change="
                  update_transaction.invoice_group_id = null;
                  update_transaction.invoice_item_id = null;
                  update_transaction.invoice_id = null;
                  getGroupOfProject();
                "
                v-else
              />
            </v-col>

            <v-col cols="3"></v-col>
            <v-col
              cols="12"
              style="display: content"
              v-if="(!sales_income   && !no_project && !misc_type && project_status=='fixed')"
            >
              <v-row>
                <v-col cols="5">
                  <v-autocomplete
                    dense
                    :items="project_group_list"
                    v-model="update_transaction.invoice_group_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    label="Invoice Group"
                    @change="
                    update_transaction.invoice_item_id = null;
                    update_transaction.expense_invoice_id = null;
                    getItemOfGroup();
                    getGroupBalance();
                    getInvoiceListWithExpense();
                    getExpenseBalanceWithInvoice();
                    
                    update_transaction.update_locked_trans = update_transaction.invoice_group_id != null;
                    is_locked = !update_transaction.update_locked_trans;
                  "
                  >
                    <template v-slot:item="{ item }">
                      <div
                        :style="{
                      fontSize: item.type === 'sub' ? '12px' : 'inherit',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      cursor:'auto',
                    }"
                        class="pointerClass"
                      >
                        <!-- Left: Item Label -->
                        <span>{{ item.type === 'sub' ? '- ' + item.text : item.text }}</span>

                        <!-- Right: Amount with tooltip (only for 'sub' type with description) -->
                        <div class="pl-2" style="white-space: nowrap;">
                          <v-tooltip v-if="item.type === 'sub' && item.description" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <span
                                  class="primary--text"
                                  v-if="item.balance >= 0"
                                >${{ getAmountFormat(item.balance) }}</span>
                                <span
                                  class="error--text"
                                  v-else
                                >${{ getAmountFormat(item.balance) }}</span>
                              </span>
                            </template>
                            <span>{{ item.description }}</span>
                          </v-tooltip>

                          <!-- No tooltip fallback -->
                          <template v-else>
                            <span
                              class="primary--text"
                              v-if="item.balance >= 0"
                            >${{ getAmountFormat(item.balance) }}</span>
                            <span class="error--text" v-else>${{ getAmountFormat(item.balance) }}</span>
                          </template>
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="col_2_width">
                  <v-checkbox
                    dense
                    v-model="check_all_group"
                    hide-details
                    label="All Group"
                    class="mt-0 pt-0"
                    @click="getGroupOfProject()"
                  ></v-checkbox>
                </v-col>

                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                >
                  <b>Cost</b>
                  <br />
                  ${{
                  group_balance_data[0] ? group_balance_data[0].cost : ""
                  }}
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                >
                  <b>Balance</b>
                  <br />$
                  <span ref="groupAmount">
                    {{
                    group_balance_data[0] ? group_balance_data[0].balance : ""
                    }}
                  </span>
                  <v-icon
                    class="ml-2"
                    size="20px"
                    @click="
                      copyGroupAmount(
                        group_balance_data[0]
                          ? group_balance_data[0].balance
                          : ''
                      )
                    "
                  >mdi-content-copy</v-icon>
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                >
                  <b>Money spent</b>
                  <br />
                  <span
                    :class="getMoneySpent < 0 ? 'error--text' : 'primary--text'"
                  >${{ getAmountFormat(getMoneySpent) }}</span>
                </div>
                <div
                  class="col_150"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                >
                  <b>Balance to Spend</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getBalanceToSpand >= 0"
                  >${{ getAmountFormat(getBalanceToSpand) }}</span>
                  <span
                    class="error--text"
                    v-if="getBalanceToSpand < 0"
                  >${{ getAmountFormat(getBalanceToSpand) }}</span>
                </div>
              </v-row>
              <v-row style="margin-top:0px;">
                <v-col cols="5">
                  <v-autocomplete
                    dense
                    :items="project_item_list"
                    v-model="update_transaction.invoice_item_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    label="Invoice Item"
                    @change="getItemBalance()"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%; display: flex; justify-content: space-between;">
                        <span>
                          {{ item.item_name }} -
                          <span style="font-size:12px;">({{ item.area }})</span>
                        </span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="pl-2">
                              <span
                                class="primary--text"
                                v-if="item.balance >= 0"
                              >${{ getAmountFormat(item.balance) }}</span>
                              <span class="error--text" v-else>${{ getAmountFormat(item.balance) }}</span>
                            </span>
                          </template>
                          <span>{{ item.description }}</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="col_2_width">
                  <v-text-field
                    dense
                    outlined
                    v-model="split_amount"
                    type="number"
                    label="Split Amount"
                  ></v-text-field>
                </v-col>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                >
                  <b>Cost</b>
                  <br />
                  ${{
                  item_balance_data[0] ? item_balance_data[0].cost : ""
                  }}
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                >
                  <b>Balance</b>
                  <br />$
                  <span ref="itemAmount">
                    {{
                    item_balance_data[0] ? item_balance_data[0].balance : ""
                    }}
                  </span>
                  <v-icon
                    class="ml-2"
                    size="20px"
                    @click="
                      copyItemAmount(
                        item_balance_data[0] ? item_balance_data[0].balance : ''
                      )
                    "
                  >mdi-content-copy</v-icon>
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                >
                  <b>Money spent</b>
                  <br />
                  <span
                    :class="
                      getItemMoneySpent < 0 ? 'error--text' : 'primary--text'
                    "
                  >${{ getAmountFormat(getItemMoneySpent) }}</span>
                </div>
                <div
                  class="col_150"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                >
                  <b>Balance to Spend</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getItemBalanceToSpand >= 0"
                  >${{ getAmountFormat(getItemBalanceToSpand) }}</span>
                  <span
                    class="error--text"
                    v-if="getItemBalanceToSpand < 0"
                  >${{ getAmountFormat(getItemBalanceToSpand) }}</span>
                </div>
              </v-row>
              <v-row
                v-if="!sales_income && !no_project && is_expense_list==true"
                style="margin-top:0px"
              >
                <v-col cols="5">
                  <v-autocomplete
                    dense
                    :items="invoice_expense_list"
                    v-model="update_transaction.expense_invoice_id"
                    item-text="invoice_number"
                    item-value="generated_inv_id"
                    outlined
                    hide-details
                    clearable
                    label="Invoice"
                    @change="getExpenseBalanceWithInvoice();"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.invoice_number }} - ( {{item.invoice_date}} )</span>
                        <span class="float-right pl-2">
                          <span class="primary--text" v-if="item.balance >= 0">${{ (item.balance) }}</span>
                          <span class="error--text" v-if="item.balance < 0">${{ (item.balance) }}</span>
                        </span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col class="col_2_width">
                  <v-text-field
                    dense
                    outlined
                    v-model="invoice_amt"
                    type="number"
                    label="invoice_amt"
                  ></v-text-field>
                </v-col>

                <div
                  class="col_110"
                  v-if="
                    update_transaction.expense_invoice_id && expense_balance_data[0]
                  "
                >
                  <b>Inv Amount</b>
                  <br />
                  ${{expense_balance_data[0] ? getAmountFormat(expense_balance_data[0].amount) : "" }}
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.expense_invoice_id && expense_balance_data[0]
                  "
                >
                  <b>Balance To Assign</b>
                  <br />$
                  <span
                    ref="invoiceAmount"
                  >{{expense_balance_data[0] ? getAmountFormat(expense_balance_data[0].balance) : ""}}</span>
                  <v-icon
                    class="ml-2"
                    size="20px"
                    @click="
                      copyInvoiceAmount(expense_balance_data[0]? getAmountFormat(expense_balance_data[0].balance)  : '')"
                  >mdi-content-copy</v-icon>
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.expense_invoice_id && expense_balance_data[0]
                  "
                >
                  <b>Assigned</b>
                  <br />
                  <span
                    :class="getInvoiceExpenseMoneySpent < 0 ? 'error--text' : 'primary--text'"
                  >${{getAmountFormat(getInvoiceExpenseMoneySpent) }}</span>
                </div>
                <div
                  class="col_150"
                  v-if="
                    update_transaction.expense_invoice_id && expense_balance_data[0]
                  "
                >
                  <b>Balance</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getInvoiceExpenseBalanceToSpand >= 0"
                  >${{ getAmountFormat(getInvoiceExpenseBalanceToSpand) }}</span>
                  <span
                    class="error--text"
                    v-if="getInvoiceExpenseBalanceToSpand < 0"
                  >${{ getAmountFormat(getInvoiceExpenseBalanceToSpand) }}</span>
                </div>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              style="display: content"
              v-if="!sales_income && !no_project && !misc_type && project_status=='cost_plus'"
            >
              <v-row>
                <v-col cols="9">
                  <v-autocomplete
                    dense
                    :items="project_group_list"
                    v-model="update_transaction.invoice_group_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    label="Invoice Group"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.text }}</span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- <v-col cols="3">
                  <v-checkbox
                    dense
                    v-model="check_all_group"
                    hide-details
                    label="All Group"
                    class="mt-0 pt-0"
                    @click="getGroupOfProject()"
                  ></v-checkbox>
                </v-col>-->
              </v-row>
            </v-col>
            <v-col
              cols="12"
              style="display: content"
              v-if="sales_income && !misc_type  && !no_project "
            >
              <v-row>
                <v-col cols="5" v-if="sales_income && !misc_type">
                  <v-autocomplete
                    dense
                    :items="project_invoice_list"
                    v-model="update_transaction.invoice_id"
                    item-text="invoice_number"
                    item-value="generated_inv_id"
                    outlined
                    hide-details
                    clearable
                    label="Invoice List"
                    @change="getInvoiceBalance();"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.invoice_number }} - ( {{item.invoice_date}} )</span>
                        <span class="float-right pl-2">
                          <span
                            class="primary--text"
                            v-if="item.balance >= 0"
                          >${{ getAmountFormat(item.balance) }}</span>
                          <span
                            class="error--text"
                            v-if="item.balance < 0"
                          >${{ getAmountFormat(item.balance) }}</span>
                        </span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col class="col_2_width">
                  <v-text-field
                    dense
                    outlined
                    v-model="split_amount"
                    type="number"
                    label="Split Amount"
                  ></v-text-field>
                </v-col>

                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "
                >
                  <b>Invoice Amount</b>
                  <br />
                  <p
                    :class="invoice_balance_data[0].amount < 0 ? 'error--text' : 'primary--text'"
                  >${{invoice_balance_data[0] ? getAmountFormat(invoice_balance_data[0].amount) : "" }}</p>
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "
                >
                  <b>Invoice Balance</b>
                  <br />
                  <p :class="invoice_balance_data[0].balance < 0 ? 'error--text' : 'primary--text'">
                    $
                    <span
                      ref="invoiceAmount"
                    >{{invoice_balance_data[0] ? getAmountFormat(invoice_balance_data[0].balance) : ""}}</span>
                    <v-icon
                      class="ml-2"
                      size="20px"
                      @click="
                      copyInvoiceAmount(invoice_balance_data[0]? getAmountFormat(invoice_balance_data[0].balance)  : '')"
                    >mdi-content-copy</v-icon>
                  </p>
                </div>
                <div
                  class="col_110"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "
                >
                  <b>Money Received</b>
                  <br />
                  <span
                    :class="getInvoiceMoneySpent < 0 ? 'error--text' : 'primary--text'"
                  >${{ getAmountFormat(getInvoiceMoneySpent) }}</span>
                </div>
                <div
                  class="col_150"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "
                >
                  <b>Balance Due</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getInvoiceBalanceToSpand >= 0"
                  >${{ getAmountFormat(getInvoiceBalanceToSpand) }}</span>
                  <span
                    class="error--text"
                    v-if="getInvoiceBalanceToSpand < 0"
                  >${{ getAmountFormat(getInvoiceBalanceToSpand) }}</span>
                </div>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              style="display: content"
              v-if="misc_type && sales_income  && !no_project "
            >
              <v-row>
                <v-col class="col_2_width">
                  <v-text-field
                    dense
                    outlined
                    v-model="split_amount"
                    type="number"
                    label="Split Amount"
                  ></v-text-field>
                </v-col>
                <!-- <v-col class="col_2_width">
                  <v-text-field
                    dense
                    outlined
                    v-model="invoice_amt"
                    type="number"
                    label="invoice_amt"
                  ></v-text-field>
                </v-col>-->

                <div
                  class="col_110"
                  v-if="
                    sales_order_data
                  "
                >
                  <b>Sales Order Amount</b>
                  <br />
                  <p
                    :class="sales_order_data.sales_order_amount < 0 ? 'error--text' : 'primary--text'"
                  >${{sales_order_data ? getAmountFormat(sales_order_data.sales_order_amount) : "" }}</p>
                </div>
                <div
                  class="col_110 ml-10"
                  v-if="
                    sales_order_data
                  "
                >
                  <b>Balance</b>
                  <br />
                  <p
                    :class="sales_order_data.money_spent_sales_income_balance < 0 ? 'error--text' : 'primary--text'"
                  >
                    $
                    <span
                      ref="invoiceAmount"
                    >{{sales_order_data ? getAmountFormat(sales_order_data.money_spent_sales_income_balance) : ""}}</span>
                    <v-icon
                      class="ml-2"
                      size="20px"
                      @click="
                      copyInvoiceAmount(sales_order_data? getAmountFormat(sales_order_data.money_spent_sales_income_balance)  : '')"
                    >mdi-content-copy</v-icon>
                  </p>
                </div>
                <div
                  class="col_110"
                  v-if="
                     sales_order_data
                  "
                >
                  <b>Money Received</b>
                  <br />
                  <span
                    :class="getSalesDataSalesIncomeMoneySpent < 0 ? 'error--text' : 'primary--text'"
                  >${{ getAmountFormat(getSalesDataSalesIncomeMoneySpent) }}</span>
                </div>
                <div
                  class="col_150"
                  v-if="
                     sales_order_data
                  "
                >
                  <b>Balance Due</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getSalesDataSalesIncomeBalanceToSpand >= 0"
                  >${{ getAmountFormat(getSalesDataSalesIncomeBalanceToSpand) }}</span>
                  <span
                    class="error--text"
                    v-if="getSalesDataSalesIncomeBalanceToSpand < 0"
                  >${{ getAmountFormat(getSalesDataSalesIncomeBalanceToSpandn) }}</span>
                </div>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              style="display: content"
              v-if="misc_type && !sales_income  && project_status=='fixed' "
            >
              <v-row>
                <v-col class="col_2_width">
                  <v-text-field
                    dense
                    outlined
                    v-model="split_amount"
                    type="number"
                    label="Split Amount"
                  ></v-text-field>
                </v-col>
                <!-- <v-col class="col_2_width">
                  <v-text-field
                    dense
                    outlined
                    v-model="invoice_amt"
                    type="number"
                    label="invoice_amt"
                  ></v-text-field>
                </v-col>-->
                <div
                  class="col_110"
                  v-if="
                    sales_order_data && update_transaction.project_id
                  "
                >
                  <b>Cost</b>
                  <br />
                  <p
                    class="error--text"
                  >${{sales_order_data ? getAmountFormat(sales_order_data.cost) : "" }}</p>
                </div>
                <div
                  class="col_110"
                  v-if="
                    sales_order_data &&  update_transaction.project_id
                  "
                >
                  <b>Balance to Spend</b>
                  <br />
                  <p class="error--text">
                    $
                    <span
                      ref="invoiceAmount"
                    >{{sales_order_data ? getAmountFormat(sales_order_data.money_spent_balance) : ""}}</span>
                    <v-icon
                      class="ml-2"
                      size="20px"
                      @click="
                      copyInvoiceAmount(sales_order_data? getAmountFormat(sales_order_data.money_spent_balance)  : '')"
                    >mdi-content-copy</v-icon>
                  </p>
                </div>
                <div
                  class="col_110"
                  v-if="
                     sales_order_data && update_transaction.project_id
                  "
                >
                  <b>Money Spent</b>
                  <br />
                  <span
                    :class="getSalesDataMoneySpent < 0 ? 'error--text' : 'primary--text'"
                  >${{ getAmountFormat(getSalesDataMoneySpent) }}</span>
                </div>
                <div
                  class="col_150"
                  v-if="
                     sales_order_data && update_transaction.project_id
                  "
                >
                  <b>Balance to Spend</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getSalesDataBalanceToSpand >= 0"
                  >${{ getAmountFormat(getSalesDataBalanceToSpand) }}</span>
                  <span
                    class="error--text"
                    v-if="getSalesDataBalanceToSpand < 0"
                  >${{ getAmountFormat(getSalesDataBalanceToSpand) }}</span>
                </div>
              </v-row>
            </v-col>

            <v-col cols="4">
              <v-menu
                v-model="transaction_date2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="update_transaction.transaction_date"
                    label="Transaction Date"
                    :disabled="update_transaction.is_lock_by_current_date == 1"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted"
                  @input="
                    transaction_date2 = false;
                    parseDate3();
                  "
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                label="Bank"
                :disabled="update_transaction.is_lock_by_current_date == 1"
                :items="banks"
                v-model="update_transaction.bank_id"
                :error-messages="update_transaction_error.bank_id"
                :hide-details="!update_transaction_error.bank_id"
                item-text="bank_name"
                item-value="bank_id"
                outlined
                clearable
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="4"></v-col>

            <v-col cols="8">
              <v-textarea
                label="Description"
                v-model="update_transaction.description"
                hide-details
                outlined
                clearable
                rows="2"
                dense
              ></v-textarea>
            </v-col>
            <v-col cols="4"></v-col>
            <v-col cols="2" class="d-flex align-center">
              <v-radio-group
                v-model="update_transaction.amount_type"
                row
                hide-details
                class="mt-0"
                dense
                :disabled="update_transaction.is_lock_by_current_date == 1"
              >
                <v-radio color="primary" value="PLUS" class="ma-0 pa-0">
                  <template v-slot:label>
                    <div class="primary--text">Cr</div>
                  </template>
                </v-radio>
                <v-radio label="Dr" color="error" value="MINUS" class="ma-0 pa-0 pl-2">
                  <template v-slot:label>
                    <div class="error--text">Dr</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Amount"
                v-model="update_transaction.amount"
                hide-details
                type="number"
                :disabled="update_transaction.is_lock_by_current_date == 1"
                :color="
                  update_transaction.amount_type == 'MINUS'
                    ? 'error'
                    : 'primary'
                "
                :class="
                  update_transaction.amount_type == 'MINUS'
                    ? 'red-font-color'
                    : 'green-font-color'
                "
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6"></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()">Cancel</v-btn>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            v-if="selected_item.childs_count==0 && selected_item.split_from_id!=null && selected_item.generate_invoice_id==null"
            @click="deleteTransactions()"
          >Delete</v-btn>
          <v-btn color="error" @click="setDefaultData()">Reset</v-btn>
          <!-- is_locked{{is_locked}}
          loading{{loading}}
          sales_income{{sales_income}}
          selected_item.generated_inv_id{{selected_item.generated_inv_id}}
          getItemBalanceToSpand{{getItemBalanceToSpand}}
          getBalanceToSpand{{getBalanceToSpand}}
          split_amount{{split_amount}}
          update_transaction.amount{{update_transaction.amount}}
          update_transaction.expense_invoice_id:{{update_transaction.expense_invoice_id}}
          getInvoiceExpenseBalanceToSpand:{{getInvoiceExpenseBalanceToSpand}}-->
          <!-- (misc_type && getSalesDataBalanceToSpand <0)|| -->
          <v-btn
            color="primary"
            :disabled="loading || is_locked  || (!sales_income  && ( getItemBalanceToSpand < 0 ||  getBalanceToSpand < 0 || parseFloat(split_amount) >  parseFloat(update_transaction.amount) ||split_amount == 0)) 
            ||  (!sales_income && update_transaction.expense_invoice_id!='' && getInvoiceExpenseBalanceToSpand < 0 ) || 
             (sales_income && (parseFloat(split_amount) >  parseFloat(update_transaction.amount) || split_amount == 0 || getInvoiceBalanceToSpand > 0))"
            @click="parseFloat(split_amount) == parseFloat(update_transaction.amount)  ? updateSingleTransaction(): splitTransaction()"
          >
            {{
            parseFloat(split_amount) == parseFloat(update_transaction.amount)
            ? "Update"
            : "Split"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
 <script>
import axios from "../../plugins/axios";
import {
  parseParams,
  getTotalOrderAmountwithAllcalculation
} from "../../plugins/helper";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      loading: false,
      check_all_group: true,
      // project_of_selected_status: [],
      vendor_selected_status: "all",
      transaction_date2: false,
      project_group_list: [],
      project_item_list: [],
      project_invoice_list: [],
      group_invoice_list: [],
      project_selected_status: "1",
      is_locked: false,
      update_transaction: {
        trans_type_id: null,
        update_locked_trans: false,
        project_id: null,
        invoice_group_id: null,
        vendor_id: null,
        expence: false,
        transaction_date: null,
        amount_type: "PLUS",
        amount: null,
        bank_id: null,
        description: null,
        invoice_item_id: null,
        invoice_id: null,
        expense_invoice_id: null
      },
      split_amount: "0",
      project_status: "",
      keywords: {
        item: null,
        vendors: [],
        expences: [],
        project: [],
        invoice_group: [],
        type: [],
        info: {}
      },
      trans_type_list: [],
      expence_list: [],
      item_list: [],
      vendor_list: [],
      banks: [],
      dateFormatted: null,
      group_balance_data: [],
      item_balance_data: [],
      invoice_balance_data: [],
      update_transaction_error: {},
      invoice_expense_list: [],
      expense_balance_data: [],
      sales_income: false,
      misc_type: false,
      is_expense_list: false,
      invoice_amt: 0,
      project_of_selected_status_new: this.project_of_selected_status,
      sales_order_data: {},
      no_project: true,
      order_types: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ]
    };
  },
  props: ["single_update_tran", "selected_item", "project_of_selected_status"],
  watch: {
    single_update_tran: function(value) {
      this.sales_income = false;
      this.misc_type = false;
      this.project_status = "";
      this.project_invoice_list = [];
      this.update_transaction.invoice_id = null;

      if (value) {
        if (
          this.selected_item.expence == true &&
          this.selected_item.vendor_id == "35"
        ) {
          this.sales_income = true;
          this.getInvoiceList();
        }
        if (
          this.selected_item.project &&
          (this.selected_item.project.project_work[0].project_work ==
            "retail_sales" ||
            this.selected_item.project.project_work[0].project_work ==
              "counter_tops")
        ) {
          this.misc_type = true;
          this.getSalesOrderReportBalance(this.selected_item.project_id);
        }
        if (this.selected_item.project_id == 26) {
          this.no_project = true;
        } else {
          this.no_project = false;
        }
        this.project_of_selected_status_new = this.project_of_selected_status;

        this.check_all_group = true;
        this.group_balance_data = [];
        this.expense_balance_data = [];
        this.setDefaultData();
        this.getGroupOfProject();
        this.getInvoiceList();
        this.getInvoiceListWithExpense();
        this.getProjectByStatus();
        this.getTransactionSelectors();
        this.getKeywords(this.selected_item);
        this.updateSingleTransaction("true");
      }
    },
    "update_transaction.vendor_id": function(newVal) {
      if (newVal === 35 && this.update_transaction.expence == true) {
        this.sales_income = true;
      } else {
        this.sales_income = false;
      }
    },
    "update_transaction.expence": function(newVal) {
      if (newVal === true && this.update_transaction.vendor_id === 35) {
        this.sales_income = true;
      } else {
        this.sales_income = false;
      }
    },
    split_amount(newVal) {
      this.invoice_amt = Math.abs(
        this.getInvoiceAmt(this.selected_item, newVal)
      ).toFixed(2);
    }
  },
  computed: {
    getMoneySpent() {
      if (
        (this.group_balance_data[0] &&
          this.selected_item &&
          this.selected_item.project &&
          this.selected_item.project.p_type == "fixed") ||
        (this.group_balance_data[0] && this.project_status == "fixed")
      ) {
        let money_spent;
        if (this.update_transaction.amount_type == "MINUS") {
          money_spent =
            parseFloat(this.group_balance_data[0].money_spent) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent =
            parseFloat(this.group_balance_data[0].money_spent) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }
        let grp_id = this.update_transaction.invoice_group_id.split("-");
        if (grp_id[1] == this.selected_item.invoice_group_id) {
          money_spent =
            parseFloat(money_spent) - parseFloat(this.selected_item.rev_amount);
        }
        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },
    getBalanceToSpand() {
      if (
        (this.group_balance_data[0] &&
          this.selected_item &&
          this.selected_item.project &&
          this.selected_item.project.p_type == "fixed") ||
        (this.group_balance_data[0] && this.project_status == "fixed")
      ) {
        let balance;
        balance =
          parseFloat(this.group_balance_data[0].cost) +
          parseFloat(this.getMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    },
    getItemMoneySpent() {
      if (
        (this.item_balance_data[0] &&
          this.selected_item &&
          this.selected_item.project &&
          this.selected_item.project.p_type == "fixed") ||
        (this.item_balance_data[0] && this.project_status == "fixed")
      ) {
        let money_spent_item;

        if (this.update_transaction.amount_type == "MINUS") {
          money_spent_item =
            parseFloat(this.item_balance_data[0].money_spent) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent_item =
            parseFloat(this.item_balance_data[0].money_spent) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }
        if (
          this.update_transaction.invoice_item_id ==
          this.selected_item.invoice_item_id
        ) {
          money_spent_item =
            parseFloat(money_spent_item) -
            parseFloat(this.selected_item.rev_amount);
        }
        return money_spent_item.toFixed(2);
      } else {
        return "";
      }
    },
    getItemBalanceToSpand() {
      if (
        (this.item_balance_data[0] &&
          this.selected_item &&
          this.selected_item.project &&
          this.selected_item.project.p_type == "fixed") ||
        (this.item_balance_data[0] && this.project_status == "fixed")
      ) {
        let balance_item;
        balance_item =
          parseFloat(this.item_balance_data[0].cost) +
          parseFloat(this.getItemMoneySpent);
        return balance_item.toFixed(2);
      } else {
        return "";
      }
    },
    getInvoiceMoneySpent() {
      if (this.invoice_balance_data[0]) {
        let money_spent;
        if (this.update_transaction.amount_type == "MINUS") {
          money_spent =
            parseFloat(this.invoice_balance_data[0].money_spent) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent =
            parseFloat(this.invoice_balance_data[0].money_spent) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }
        let invoice_id = this.update_transaction.invoice_id;
        if (invoice_id == this.selected_item.generated_inv_id) {
          money_spent =
            parseFloat(money_spent) - parseFloat(this.selected_item.rev_amount);
        }
        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },
    getInvoiceBalanceToSpand() {
      if (this.invoice_balance_data[0]) {
        let balance;
        balance =
          parseFloat(this.invoice_balance_data[0].amount) +
          parseFloat(this.getInvoiceMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    },
    getSalesDataMoneySpent() {
      if (this.sales_order_data) {
        let money_spent;
        if (this.update_transaction.amount_type == "MINUS") {
          money_spent =
            parseFloat(this.sales_order_data.money_spent) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent =
            parseFloat(this.sales_order_data.money_spent) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }

        if (
          this.misc_type &&
          !this.sales_income &&
          this.selected_item.generated_inv_id
        ) {
          money_spent =
            parseFloat(money_spent) -
            parseFloat(this.selected_item.invoice_amt);
        }
        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },

    getSalesDataBalanceToSpand() {
      if (this.sales_order_data) {
        let balance;
        balance =
          parseFloat(this.sales_order_data.cost) +
          parseFloat(this.getSalesDataMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    },

    getSalesDataSalesIncomeMoneySpent() {
      if (this.sales_order_data) {
        let money_spent;
        if (this.update_transaction.amount_type == "MINUS") {
          money_spent =
            parseFloat(this.sales_order_data.money_spent_sales_income) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent =
            parseFloat(this.sales_order_data.money_spent_sales_income) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }

        if (
          this.misc_type &&
          this.sales_income &&
          this.selected_item.generated_inv_id
        ) {
          money_spent =
            parseFloat(money_spent) -
            parseFloat(this.selected_item.invoice_amt);
        }
        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },

    getSalesDataSalesIncomeBalanceToSpand() {
      if (this.sales_order_data) {
        let balance;
        balance =
          parseFloat(this.sales_order_data.sales_order_amount) -
          parseFloat(this.getSalesDataSalesIncomeMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    },
    getInvoiceExpenseMoneySpent() {
      if (this.expense_balance_data[0]) {
        let money_spent;

        if (this.update_transaction.amount_type == "MINUS") {
          money_spent =
            parseFloat(this.expense_balance_data[0].money_spent) -
            (this.invoice_amt ? parseFloat(this.invoice_amt) : "0");
        } else {
          money_spent =
            parseFloat(this.expense_balance_data[0].money_spent) +
            (this.invoice_amt ? parseFloat(this.invoice_amt) : "0");
        }
        let invoice_id = this.update_transaction.expense_invoice_id;

        if (invoice_id == this.selected_item.generated_inv_id) {
          money_spent =
            parseFloat(money_spent) -
            parseFloat(this.selected_item.invoice_amt);
        }
        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },
    getInvoiceExpenseBalanceToSpand() {
      if (
        this.expense_balance_data[0] &&
        this.update_transaction.expense_invoice_id
      ) {
        let balance;
        balance =
          parseFloat(this.expense_balance_data[0].amount) +
          parseFloat(this.getInvoiceExpenseMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    }
  },
  components: {},
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    enableUpdate() {
      if (this.update_transaction.update_locked_trans == true) {
        this.is_locked = false;
      }
    },

    copyGroupAmount(amount) {
      this.selectText(this.$refs.groupAmount); // e.g. <div ref="text">
      document.execCommand("copy");
      this.split_amount = amount;
    },
    copyItemAmount(amount) {
      this.selectText(this.$refs.itemAmount); // e.g. <div ref="text">
      document.execCommand("copy");
      this.split_amount = amount;
    },
    copyInvoiceAmount(amount) {
      this.selectText(this.$refs.invoiceAmount); // e.g. <div ref="text">
      document.execCommand("copy");
      this.split_amount = amount;
    },
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    getGroupBalance() {
      this.group_balance_data = this.project_group_list.filter(item => {
        if (item.value == this.update_transaction.invoice_group_id) {
          return item;
        }
      });
    },
    getInvoiceBalance() {
      this.invoice_balance_data = this.project_invoice_list.filter(item => {
        if (item.generated_inv_id == this.update_transaction.invoice_id) {
          return item;
        }
      });
    },
    getExpenseBalanceWithInvoice() {
      if (this.update_transaction.expense_invoice_id) {
        this.expense_balance_data = this.invoice_expense_list.filter(item => {
          if (
            item.generated_inv_id == this.update_transaction.expense_invoice_id
          ) {
            return item;
          }
        });
      } else {
        this.update_transaction.invoice_id = null;
      }
    },
    getItemBalance() {
      this.item_balance_data = this.project_item_list.filter(item => {
        if (item.value == this.update_transaction.invoice_item_id) {
          return item;
        }
      });
    },
    getProjectType() {
      const project = this.project_of_selected_status_new.find(
        p => p.value === this.update_transaction.project_id
      );
      if (
        (project && project.project_work === "counter_tops") ||
        project.project_work === "retail_sales"
      ) {
        this.misc_type = true;
        this.getSalesOrderReportBalance(this.update_transaction.project_id);
      } else {
        this.misc_type = false;
      }
      if (project && project.p_type == "fixed") {
        this.project_status == "fixed";
      } else {
        this.project_status == "cost_plus";
      }

      if (this.update_transaction.project_id == 26) {
        this.no_project = true;
      } else {
        this.no_project = false;
      }
    },
    getSalesOrderReportBalance(project_id) {
      let _self = this;
      this.loading = true;
      axios
        .get("get_sales_invoice_report_details?project_id=" + project_id)
        .then(response => {
          if (response.data.status) {
            let data = response.data.summary;
            this.sales_order_data = {
              sales_order_amount: data.salesOrderAmount,
              cost: data.costTotal,
              money_spent: data.money_spent,
              money_spent_balance: data.money_spent_balance,
              money_spent_sales_income: data.money_spent_sales_income,
              money_spent_sales_income_balance:
                data.money_spent_sales_income_balance
            };
          }
          _self.loading = false;
        })
        .catch(function() {});
    },
    getInvoiceListWithExpense() {
      let _self = this;
      _self.loading = true;

      axios
        .get(
          "get_invoice_of_group_with_expense?project_id=" +
            _self.update_transaction.project_id +
            "&project_data_id=" +
            _self.update_transaction.invoice_item_id +
            "&vendor_id=" +
            _self.update_transaction.vendor_id +
            "&group_id=" +
            _self.update_transaction.invoice_group_id +
            "&check_all_group=" +
            _self.check_all_group +
            "&amount_type=" +
            _self.update_transaction.amount_type
        )
        .then(response => {
          if (response.data.status) {
            _self.invoice_expense_list = response.data.data;
            _self.invoice_expense_list = _self.invoice_expense_list.filter(
              item => {
                if (
                  item.balance != 0.0 ||
                  _self.selected_item.generated_inv_id == item.generated_inv_id
                ) {
                  return item;
                }
              }
            );

            if (
              _self.invoice_expense_list.length > 0 ||
              _self.selected_item.is_for_expense == 1
            ) {
              this.is_expense_list = true;
            } else {
              _self.is_expense_list = false;
            }
          }
          _self.loading = false;
          _self.getExpenseBalanceWithInvoice();
        })
        .catch(function() {});
    },

    getItemOfGroup() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_item_of_group_with_balance?project_id=" +
            this.update_transaction.project_id +
            "&project_data_id=" +
            this.update_transaction.invoice_item_id +
            "&vendor_id=" +
            this.update_transaction.vendor_id +
            "&group_id=" +
            this.update_transaction.invoice_group_id +
            "&check_all_group=" +
            this.check_all_group +
            "&amount_type=" +
            this.update_transaction.amount_type
        )
        .then(response => {
          if (response.data.status) {
            _self.project_item_list = response.data.data;
            _self.project_item_list = _self.project_item_list.filter(item => {
              if (
                item.balance != 0.0 ||
                _self.selected_item.invoice_item_id == item.value
              ) {
                return item;
              }
            });
          }
          _self.loading = false;
          _self.getItemBalance();
        })
        .catch(function() {});
    },
    getInvoiceList() {
      if (
        this.update_transaction.project_id != null &&
        this.update_transaction.project_id != ""
      ) {
        let _self = this;
        _self.loading = true;
        axios
          .get(
            "get_project_invoice_list_with_balance?project_id=" +
              this.update_transaction.project_id
          )
          .then(response => {
            _self.project_invoice_list = response.data.invoice_list;
            _self.project_invoice_list = _self.project_invoice_list.filter(
              item => {
                if (
                  item.balance != 0.0 ||
                  _self.selected_item.generated_inv_id == item.generated_inv_id
                ) {
                  return item;
                }
              }
            );
            _self.project_item_list = _self.project_item_list.filter(item => {
              if (
                item.balance != 0.0 ||
                _self.selected_item.invoice_item_id == item.value
              ) {
                return item;
              }
            });

            _self.loading = false;
            _self.getInvoiceBalance();
          })
          .catch(function(error) {
            console.log(error);
            _self.loading = false;
          });
      }
    },
    getGroupOfProject() {
      let _self = this;
      if (
        _self.update_transaction.project_id != null &&
        _self.update_transaction.project_id != ""
      ) {
        _self.loading = true;

        axios
          .get(
            "get_group_of_project_with_balance?project_id=" +
              this.update_transaction.project_id +
              "&vendor_id=" +
              this.update_transaction.vendor_id +
              "&check_all_group=" +
              this.check_all_group +
              "&amount_type=" +
              this.update_transaction.amount_type
          )
          .then(response => {
            if (response.data.status) {
              _self.loading = false;
              _self.project_group_list = response.data.data;
              _self.project_status = response.data.project_type;
              _self.project_group_list = _self.project_group_list.filter(
                item => {
                  let grp_cha = item.value;
                  let val = grp_cha.split("-");
                  if (
                    item.balance != 0.0 ||
                    (_self.selected_item.invoice_group_id == val[1] &&
                      _self.selected_item.change_order == val[0])
                  ) {
                    return item;
                  }
                }
              );

              let transformedList = [];
              _self.project_group_list.forEach(group => {
                let mainGroup = {
                  value: group.value,
                  change_order: group.change_order,
                  text: group.text,
                  cost: group.cost,
                  money_spent: group.money_spent,
                  balance: group.balance,
                  type: "main"
                };
                transformedList.push(mainGroup);
                group.items.forEach(item => {
                  let subItem = {
                    ...item,
                    type: "sub",
                    disabled: true
                  };
                  if (item.balance != 0.0) {
                    transformedList.push(subItem);
                  }
                });
              });

              _self.project_group_list = transformedList;

              _self.getGroupBalance();
              _self.getItemOfGroup();
              _self.getInvoiceListWithExpense();
              _self.getExpenseBalanceWithInvoice();
            }
            _self.loading = false;
          })
          .catch(function() {});
      } else {
        _self.project_group_list = [];
        _self.project_selected_status = "1";
        _self.getProjectByStatus();
      }
    },
    updateSingleTransaction(check_is_update) {
      let _self = this;
      this.loading = true;
      this.update_transaction_error = {};
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      _self.update_transaction.company_id = company_data.company_id;
      _self.update_transaction.check_is_update = check_is_update;
      _self.update_transaction.invoice_amt = _self.invoice_amt;
      _self.update_transaction.sales_order_data =
        _self.update_transaction.project_id && _self.misc_type
          ? _self.misc_type
          : false;
      axios
        .post("edit_transaction", _self.update_transaction)
        .then(function(response) {
          let data = response.data;
          if (!data.status) {
            if (check_is_update) {
              if (response.data.display_success_msg) {
                _self.is_locked = true;
              } else {
                _self.is_locked = false;
              }
            } else {
              for (let key in data.errors) {
                _self.update_transaction_error[key] = data.errors[key][0];
              }
            }
          } else {
            if (response.data.display_success_msg) {
              _self.setAlert({
                show: true,
                variant: "primary",
                message: response.data.message,
                dismissCountDown: 0
              });
            }
            _self.$emit("updateValue");
            // axios
            // .post("set_keywords", _self.keywords)
            // .then(function(res) {
            //   let data = res.data;
            //   if (data.status) {
            //     _self.keywords.item = null;
            //     _self.keywords.vendors = [];
            //     _self.keywords.expences = [];
            //     _self.keywords.invoice_group = [];
            //     _self.keywords.project = [];
            //     _self.keywords.type = [];
            //     _self.keywords.info = {};
            //     _self.$emit('updateValue');
            //   }
            // })
            // .then(function() {
            // });
          }
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    splitTransaction() {
      let _self = this;
      let sData = {};
      sData.trans_id = this.update_transaction.id;
      sData.amount = _self.split_amount;
      sData.invoice_item_id = this.update_transaction.invoice_item_id;
      sData.invoice_group_id = this.update_transaction.invoice_group_id;
      sData.invoice_id = this.update_transaction.invoice_id;
      sData.expense_invoice_id = this.update_transaction.expense_invoice_id;
      sData.for_item_balance = true;
      sData.invoice_amt = this.invoice_amt;
      sData.sales_order_data = this.misc_type;
      axios
        .post("split_transaction", sData)
        .then(function(response) {
          if (response.data.status) {
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            _self.$emit("updateValue");
          } else {
            // for (let key in response.data.errors) {
            //   _self.split_amount_error = response.data.errors[key][0];
            // }
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    setDefaultData() {
      this.update_transaction_error = {};
      this.update_transaction.id = this.selected_item.trans_id;
      this.update_transaction.trans_type_id = this.selected_item.trans_type_id;
      this.update_transaction.update_locked_trans = false;
      this.update_transaction.project_id = Number(
        this.selected_item.project_id
      );
      this.update_transaction.invoice_group_id =
        this.selected_item.change_order +
        "-" +
        this.selected_item.invoice_group_id;

      this.update_transaction.vendor_id = this.selected_item.vendor_id;
      this.update_transaction.invoice_item_id = this.selected_item.invoice_item_id;
      this.update_transaction.expence = this.selected_item.expence;
      this.update_transaction.description = this.selected_item.description;
      this.update_transaction.is_lock_by_current_date = this.selected_item.is_lock_by_current_date;
      this.update_transaction.invoice_id = this.selected_item.generated_inv_id;
      this.dateFormatted = this.selected_item.trans_date;
      this.parseDate3();
      if (this.selected_item.rev_amount < 0) {
        this.update_transaction.amount_type = "MINUS";
      } else {
        this.update_transaction.amount_type = "PLUS";
      }
      this.update_transaction.amount = this.getAmountFormat(
        this.selected_item.rev_amount
      );
      this.split_amount = this.update_transaction.amount;
      let status = 1;
      if (this.selected_item.project_id == "") {
        status = "1";
      } else {
        let project_status = this.selected_item?.project?.p_active;
        if (project_status == true) {
          status = "1";
        } else {
          status = "0";
        }
      }
      this.update_transaction.bank_id = this.selected_item.bank_id;
      this.project_selected_status = status;
      this.vendor_selected_status =
        this.selected_item.vendor_id == "" ? "1" : "all";
      // if (this.project_selected_status == "all") {
      this.getProjectByStatus();
      // }

      this.update_transaction.expense_invoice_id = this.selected_item.generated_inv_id;
      if (this.selected_item.is_for_expense == 1) {
        this.is_expense_list = true;
      } else {
        this.is_expense_list = false;
      }
      setTimeout(() => {
        this.invoice_amt = this.selected_item.invoice_amt
          ? Math.abs(this.selected_item.invoice_amt).toFixed(2)
          : this.getInvoiceAmt(this.selected_item).toFixed(2);
      }, 1000);
    },
    getInvoiceAmt(item, amount = "") {
      let val = amount ? amount : item.rev_amount;
      let total = this.getAmountFormat(val);
      total = getTotalOrderAmountwithAllcalculation(
        item.project.p_price,
        item.project.multiplier,
        val
      );
      return Math.abs(total);
    },
    closePopup() {
      this.$emit("closePopup");
    },
    getAmountFormat(value) {
      if (value) {
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    getKeywords(item) {
      let _self = this;
      this.keywords.item = item;
      this.loading = true;
      axios
        .get("get_keywords?" + parseParams(item))
        .then(function(res) {
          let data = res.data;
          if (data.status) {
            _self.keywords.vendors = data.data.keywords.vendor;
            _self.keywords.expences = data.data.keywords.expence;
            _self.keywords.project = data.data.keywords.project;
            _self.keywords.invoice_group = data.data.keywords.invoice_group;
            _self.keywords.type = data.data.keywords.type;
            _self.keywords.info = data.data.keywords.info;
          }
          _self.loading = false;
        })
        .then(function() {
          _self.loading = false;
        });
    },
    getTransactionSelectors() {
      let _self = this;
      // this.loading = true;
      axios
        .get("update_transaction_data?status=" + this.vendor_selected_status)
        .then(response => {
          if (response.data.status) {
            _self.trans_type_list = response.data.data.trans_types;
            _self.expence_list = response.data.data.expences;
            _self.item_list = response.data.data.items;
            _self.vendor_list = response.data.data.vendors;
            _self.banks = response.data.data.banks;
          }
          // _self.loading = false;
        })
        .catch(function() {});
    },
    parseDate3() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.update_transaction.transaction_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    setFocus(className) {
      document.querySelectorAll("." + className + " input")[0].focus();
    },
    getProjectByStatus() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_project_by_status?status=" + this.project_selected_status)
        .then(response => {
          if (response.data.status) {
            _self.project_of_selected_status_new = response.data.data;
          }
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    deleteTransactions() {
      this.loading = true;
      let _self = this;
      let ids = [];
      ids.push(_self.selected_item.trans_id);
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      axios
        .post("delete_transaction", {
          ids: ids,
          company_id: company_data.company_id,
          is_from_split_delete:
            _self.update_transaction.update_locked_trans == true ? true : false
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.$emit("updateValue");
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
          console.log("FAILURE!!");
        });
    }
  },
  created: function() {},
  mounted: function() {}
};
</script>
<style scoped>
.col_110 {
  width: 130px;
  margin-top: 10px;
}
.col_150 {
  width: 130px;
  margin-top: 10px;
}
.col_2_width {
  max-width: 12.666667% !important;
}
.pointerClass {
  pointer-events: auto !important;
}
</style>